

























































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { EState, IDropDown } from '../Layout/SharedFolderLayout.vue'

@Component
export default class MobileButtonArea extends Vue {
  @Prop() actionAreaState!: EState
  @Prop() roleEditFile!: boolean
  @Prop() isSelectAnyItem!: boolean
  @Prop() private checkAll!: boolean
  @Prop() sortSelected!: any
  @Prop() sortOptions!: IDropDown[]
  @Prop() folderSelected!: any
  @Prop() folderOptions!: IDropDown[]
  @Prop() filesLength!: number

  checkAllClone: boolean = this.checkAll
  isCommonTopic = !this.$route.params.groupId
  eState = EState

  @Watch('checkAll')
  watchCheckAll() {
    this.checkAllClone = this.checkAll
  }

  handleMoveToUnclassified(isFromBin: boolean) {
    this.$emit('handleMoveToUnclassified', isFromBin)
  }

  openConfirmDeleteBin(isFromBin: boolean) {
    this.$emit('openConfirmDeleteBin', isFromBin)
  }

  handleSortChange(index: number) {
    this.$emit('handleSortChange', index)
  }

  handleSelectFolder(index: number) {
    this.$emit('handleSelectFolder', index)
  }

  handleCheckAll() {
    this.$emit('handleCheckAll', this.checkAllClone)
  }

  jumpToCreateFilePage() {
    this.$emit('jumpToCreateFilePage')
  }

  openEditFolderModal() {
    this.$emit('openEditFolderModal')
  }

  handleDownloadFiles() {
    this.$emit('handleDownloadFiles')
  }

  pinMultipleFiles() {
    this.$emit('pinMultipleFiles')
  }
}
